import React from "react";
import { PenLine } from "lucide-react";
import { StarRating } from "@/components/common/StarRating";

export function ReviewSummary({ summary, ratingFilter, onFilter, onWrite }) {
  const { average = 0, count = 0, written_count = 0, distribution = {} } = summary || {};
  const maxBar = Math.max(1, ...Object.values(distribution));

  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-[auto_1fr_auto] md:items-center">
      <div className="text-center md:text-left">
        <p className="font-serif text-6xl font-light leading-none text-ink" data-testid="reviews-average">{count ? average.toFixed(1) : "—"}</p>
        <StarRating rating={average} size={18} className="mt-3 justify-center md:justify-start" />
        <p className="mt-2 text-sm text-muted-foreground" data-testid="reviews-count">
          {count ? `Based on ${count} ${count === 1 ? "review" : "reviews"}` : "No reviews yet"}
        </p>
      </div>

      <div className="space-y-2" data-testid="reviews-distribution">
        {[5, 4, 3, 2, 1].map((star) => {
          const n = distribution[String(star)] || 0;
          const active = ratingFilter === star;
          return (
            <button
              key={star}
              type="button"
              onClick={() => onFilter(active ? null : star)}
              disabled={!n}
              data-testid={`reviews-filter-${star}`}
              className={`group flex w-full items-center gap-3 text-left disabled:cursor-default ${active ? "text-gold" : "text-ink"}`}
            >
              <span className="w-12 text-xs tracking-wider">{star} star</span>
              <span className="h-1.5 flex-1 bg-cream">
                <span
                  className={`block h-full transition-[width] duration-700 ${active ? "bg-gold" : "bg-gold/70 group-hover:bg-gold"}`}
                  style={{ width: `${written_count ? (n / maxBar) * 100 : 0}%` }}
                />
              </span>
              <span className="w-6 text-right text-xs text-muted-foreground">{n}</span>
            </button>
          );
        })}
      </div>

      <div className="text-center md:text-right">
        <button
          type="button"
          onClick={onWrite}
          data-testid="reviews-write-button"
          className="inline-flex items-center gap-2 border border-ink px-7 py-3.5 text-[11px] font-medium uppercase tracking-[0.18em] text-ink transition-colors hover:bg-ink hover:text-ivory"
        >
          <PenLine size={14} /> Write a Review
        </button>
        <p className="mt-3 text-xs text-muted-foreground">Share photos of your piece</p>
      </div>
    </div>
  );
}
